var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-list-item",class:_vm.itemClass,attrs:{"title":((_vm.contact.name) + " is " + (_vm.contact.chat_status))}},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.contact.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }